// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import axios from "axios";

// const WorkerQuantity = () => {
//   const { id } = useParams();
//   const [productStats, setProductStats] = useState({});
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchBills = async () => {
//       try {
//         const res = await axios.get(
//           `http://localhost/murugan/bills/get_by_worker.php?worker_id=${id}`
//         );

//         const usageBills = res.data.filter((bill) => bill.type !== "deduction");

//         const productCount = {};
//         usageBills.forEach((bill) => {
//           bill.items.forEach((item) => {
//             productCount[item.product] =
//               (productCount[item.product] || 0) + item.quantity;
//           });
//         });

//         setProductStats(productCount);
//       } catch (err) {
//         console.error("Failed to fetch product stats", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchBills();
//   }, [id]);

//   if (loading)
//     return (
//       <p className="text-muted text-center mt-4">Loading product stats...</p>
//     );

//   if (Object.keys(productStats).length === 0) {
//     return (
//       <p className="text-muted text-center mt-4">No product stats available.</p>
//     );
//   }

//   return (
//     <div className="p-6">
//       <h2 className="text-success mb-4 text-2xl font-semibold">
//         📦 Product Usage Summary
//       </h2>
//       <div className="row">
//         {Object.entries(productStats).map(([product, count]) => (
//           <div key={product} className="col-md-4 mb-4">
//             <div className="card shadow-sm h-100">
//               <div className="card-body">
//                 <h5 className="card-title text-primary">{product}</h5>
//                 <p className="card-text">
//                   <strong>Stock:</strong> {count}
//                 </p>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default WorkerQuantity;

// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import {
//   ShoppingCart,
//   FileText,
//   CreditCard,
//   ClipboardList,
// } from "lucide-react";
// import { Api } from "../Api/Api";

// const WorkerQuantity = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [productStats, setProductStats] = useState({});
//   const [loading, setLoading] = useState(true);

//   // ✅ Get current user from localStorage
//   const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
//   const username = currentUser?.username || "Worker";
//   const workerId = currentUser?.id;

//   // Gradient sets for quick actions
//   const quickActionColors = [
//     "bg-gradient-to-r from-green-600 to-green-800 text-white",
//     "bg-gradient-to-r from-orange-500 to-red-600 text-white",
//     "bg-gradient-to-r from-blue-600 to-cyan-700 text-white",
//     "bg-gradient-to-r from-purple-600 to-indigo-700 text-white",
//   ];

//   // Gradient sets for product summary
//   const summaryColors = [
//     "bg-gradient-to-r from-yellow-500 to-amber-600 text-white",

//     "bg-gradient-to-r from-indigo-500 to-blue-700 text-white",
//   ];

//   useEffect(() => {
//     const fetchBills = async () => {
//       try {
//         const res = await axios.get(
//           `${Api}bills/get_by_worker.php?worker_id=${id}`
//         );

//         const usageBills = res.data.filter((bill) => bill.type !== "deduction");

//         const productCount = {};
//         usageBills.forEach((bill) => {
//           bill.items.forEach((item) => {
//             productCount[item.product] =
//               (productCount[item.product] || 0) + item.quantity;
//           });
//         });

//         setProductStats(productCount);
//       } catch (err) {
//         console.error("Failed to fetch product stats", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchBills();
//   }, [id]);

//   if (loading)
//     return (
//       <p className="text-muted text-center mt-4">Loading product stats...</p>
//     );

//   return (
//     <div className="p-2">
//       {/* Welcome */}
//       <h2 className="text-2xl font-bold mb-2">👋 Welcome back, {username}</h2>
//       <p className="text-gray-600 mb-6">
//         Here’s a quick overview of your tasks and product usage 🚀
//       </p>

//       {/* Quick Actions */}
//       <h3 className="text-xl font-semibold mb-3">⚡ Quick Actions</h3>
//       <div className="row mb-6">
//         {[
//           {
//             title: "New Retail Bill",
//             icon: <ShoppingCart size={28} />,
//             path: `/worker/billing/${workerId}`,
//           },
//           {
//             title: "Customer Bills",
//             icon: <FileText size={28} />,
//             path: `/worker/retail/${workerId}`,
//           },
//           {
//             title: "Credit Details",
//             icon: <CreditCard size={28} />,
//             path: `/worker/credit/${workerId}`,
//           },
//           {
//             title: "My Bills",
//             icon: <ClipboardList size={28} />,
//             path: `/worker/dashboard/${workerId}`,
//           },
//         ].map((action, idx) => (
//           <div key={idx} className="col-md-3 col-sm-6 mb-4">
//             <div
//               className={`card text-center shadow-sm h-100 ${
//                 quickActionColors[idx % quickActionColors.length]
//               }`}
//               style={{
//                 borderRadius: "12px",
//                 transition: "all 0.2s",
//                 cursor: "pointer",
//               }}
//               onClick={() => navigate(action.path)}
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.transform = "translateY(-4px)";
//                 e.currentTarget.style.boxShadow = "0 8px 18px rgba(0,0,0,0.2)";
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.transform = "translateY(0)";
//                 e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.1)";
//               }}
//             >
//               <div className="card-body">
//                 <div className="mb-2">{action.icon}</div>
//                 <h6 className="card-title">{action.title}</h6>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Product Usage Summary */}
//       <h3 className="text-xl font-semibold mb-3">📦 Product Usage Summary</h3>
//       <div className="row">
//         {Object.entries(productStats).map(([product, count], i) => (
//           <div key={product} className="col-md-3 col-sm-6 mb-4">
//             <div
//               className={`card shadow-sm h-100 ${
//                 summaryColors[i % summaryColors.length]
//               }`}
//               style={{
//                 borderRadius: "12px",
//                 transition: "transform 0.2s, box-shadow 0.2s",
//                 cursor: "pointer",
//               }}
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.transform = "translateY(-5px)";
//                 e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.2)";
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.transform = "translateY(0)";
//                 e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.1)";
//               }}
//             >
//               <div className="card-body">
//                 <h5 className="card-title">{product}</h5>
//                 <p className="card-text">
//                   <strong>Stock Used:</strong> {count}
//                 </p>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default WorkerQuantity;

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  ShoppingCart,
  FileText,
  CreditCard,
  ClipboardList,
} from "lucide-react";


const WorkerQuantity = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const username = currentUser?.username || "Worker";
  const workerId = currentUser?.id;



  

  // Gradient sets for quick actions
  const quickActionColors = [
    "bg-gradient-to-r from-green-600 to-green-800 text-white",
    "bg-gradient-to-r from-orange-500 to-red-600 text-white",
    "bg-gradient-to-r from-blue-600 to-cyan-700 text-white",
    "bg-gradient-to-r from-purple-600 to-indigo-700 text-white",
  ];

  useEffect(() => {
    // Simulate loading
    const timer = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timer);
  }, []);

  if (loading)
    return (
      <p className="text-gray-500 text-center mt-8 text-lg">
        Loading your dashboard...
      </p>
    );

  return (
    <div className="p-4 md:p-6">
      {/* Welcome */}
      <h2 className="text-2xl font-bold mb-2">👋 Welcome back, {username}</h2>
      <p className="text-gray-600 mb-8">
        Here’s a quick overview of your tasks 🚀
      </p>

      {/* Quick Actions */}
      <h3 className="text-xl font-semibold mb-4">⚡ Quick Actions</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {[
          {
            title: "New Retail Bill",
            icon: <ShoppingCart size={28} />,
            path: `/worker/billing/${workerId}`,
          },
          {
            title: "Customer Bills",
            icon: <FileText size={28} />,
            path: `/worker/retail/${workerId}`,
          },
          {
            title: "Retail Credit Details",
            icon: <CreditCard size={28} />,
            path: `/worker/credit/${workerId}`,
          },
          {
            title: " New Wholesale Bills",
            icon: <ClipboardList size={28} />,
            path: `/worker/wholesale/${workerId}`,
          },
        ].map((action, idx) => (
          <div key={idx}>
            <div
              className={`rounded-xl shadow-md h-32 flex flex-col items-center justify-center p-4 text-center transition-transform duration-200 cursor-pointer ${
                quickActionColors[idx % quickActionColors.length]
              }`}
              onClick={() => navigate(action.path)}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "translateY(-4px)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "translateY(0)")
              }
            >
              <div className="mb-2">{action.icon}</div>
              <span className="font-semibold">{action.title}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkerQuantity;
